<template>
  <el-dialog :visible="visible" :before-close="chartBeforeClose" v-if="inDialog">
    <highcharts :options="options()"></highcharts>
  </el-dialog>
  <highcharts v-else :options="options()"></highcharts>
</template>

<script>

  export default {
    name: "grafico-line-dialogo",
    props: {
      inDialog: {
        default: true,
        type: Boolean
      },
      visible: {
        type: Boolean
      },
      categorias: {
        required: true
      },
      axioy: {
        required: true,
        type: Object
      },
      title: {
        type: String
      },
      subtitle: {
        type: String
      },
      series: {
        type: Array
      }
    },
    methods: {
      chartBeforeClose() {
        this.$emit('update:visible', false)
      },
      options() {
        return {
          title: {
            text: this.title
          },
          subtitle: {
            text: this.subtitle
          },
          xAxis: {
            categories: this.categorias
          },
          yAxis: {
            title: {
              text: this.axioy.title
            }
          },
          series: this.series.map(item => {
              return {
                type: 'line',
                ...item
              }
            })

        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Shared/GraficoLineDialogo.vue